<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Capitanes de Puerto</h4>
            <p>Administracion de los Capitanes de Puerto {{ cDtsUser.roleAssign }}</p>        
        </div>
    </div>
    
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#nav-capitan" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="th-list" /> Listado</a>
            <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-new-capitan" role="tab" aria-controls="nav-new" aria-selected="false" v-if="cDtsUser.roleAssign !== 'SEGURIDAD' && cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'"><font-awesome-icon icon="user-plus"  /> Agregar</a>
            <a class="nav-item nav-link" id="nav-delete-capitan" data-toggle="tab" href="#nav-del-capitan" role="tab" aria-controls="nav-del" aria-selected="false" v-if="cDtsUser.roleAssign !== 'SEGURIDAD' && cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'  "><font-awesome-icon icon="user-minus" /> Baja</a>
        </div>
    </nav>
            
    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="nav-capitan" role="tabpanel" aria-labelledby="nav-capitan-tab">
            <br><br>                                    

            <button class="btn btn-outline-primary col-12 col-md-4 offset-md-2" @click="listCapitan">
                <font-awesome-icon icon="list" size="2x" /> Listar Capitanes
            </button>
            <button class="btn btn-outline-success col-12 col-md-4" @click="mCopyToClipboard('printTable')">
                <font-awesome-icon icon="file-excel" size="2x" /> Copiar 
            </button>
            <br><br>
            <div class="col-12 table-responsive-md">
                <transition name="fade" mode="out-in">
                <div id="printTable">
                <table class="table table-hover" v-if="capitanList">
                    <thead>
                        <tr>
                            <th scope="col" class="table-dark">#</th>
                            <th scope="col" class="table-dark">GG.UU.</th>
                            <th scope="col" class="table-dark">CAPITANIA</th>
                            <th scope="col" class="table-dark">CAPITAN DE PUERTO</th>
                        </tr>
                    </thead>   
                    <!-- <tbody>
                        <tr v-for="(value, index) in capitanList" :key="index">
                            <td>{{ index + 1}}</td>
                            
                            <td>{{value.district_short}}</td>
                            
                            <td>{{value.type_short}} {{value.name_port}}</td>
                            <td>{{value.data_boss}}</td>
                        </tr>
                    </tbody> -->
                    <tbody v-html="capitanList">

                    </tbody>
                </table>
                </div>
                </transition>
            </div>
        </div>
        <!-- end first tab -->

        <div class="tab-pane fade" id="nav-new-capitan" role="tabpanel" aria-labelledby="nav-new-tab">
            <br>
            
                <vue-bootstrap-typeahead                            
                    class="col-12 col-md-6 offset-md-3"
                    v-model="persons"
                    :data="persons_list"
                    size="sm"
                    :serializer="item => (`${item.grade} ${item.speciality} ${item.complete}`)"
                    @hit="mSelectPerson"
                    :placeholder="'Busqueda de Capitan de Puerto'"                                        
                />
            <div v-if="person_select.id > 0">
                <div class="form-row" >
                    <div class="form-group col-12 col-md-4 offset-md-2">
                        <label for="capitania boss">Capitania</label>         
                        <select name="captain_download" class="form-control" id="captain_download" v-model="port_select">
                            <option v-for="port in ports_vigency" :value="port" :key="port.id">{{ port.name_port }}</option>
                        </select>
                    </div>
                        
                    <div class="form-group col-12 col-md-4">
                        <label for="category_boss">Grado, Nombres y Apellidos</label>
                        <input type="text" readonly class="form-control-plaintext" name="category_boss" v-model="person_select.complete" placeholder="Ejm.: CF. DAEN Pepito Perez" autocomplete="off">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-12 col-md-4 offset-md-2">
                        <label for="telephone_boss">Telefono</label>
                        <input type="number" class="form-control-plaintext" readonly name="telephone_boss" v-model="telephone" placeholder="Ejm.: 7251587" autocomplete="off">
                    </div>

                    <div class="form-group col-12 col-md-4">
                        <label for="date_begin">Fecha Inicio Rol</label>
                        <!-- <input type="date" class="form-control" v-model="date_begin" name="date_begin" 
                        autocomplete="off"> -->
                        <datetime v-model="date_begin" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz" ></datetime>
                    </div>
                    
                </div>                                        

                <button class="btn btn-outline-info col-12 col-md-2 offset-md-5" :disabled="is_disabled" @click="sendNewCapitan">
                    <font-awesome-icon icon="save" size="2x" /> Guardar
                </button>
            </div>
        </div>

        <div class="tab-pane fade" id="nav-del-capitan" role="tabpanel" aria-labelledby="nav-del-tab">
            <br>
            <div class="form-inline">
                <div class="form-group mb-2 col-12 col-md-5 offset-md-3">
                    <label for="capitania boss">Capitania</label>         
                    <select name="captain_download" class="form-control" id="captain_download" v-model="port_select_d">
                        <option v-for="port in ports_vigency" :value="port" :key="port.id">{{ port.name_port }}</option>
                    </select>
                </div>
                
                <button class="btn btn-outline-info mb-2 col-12 col-md-1" @click="listCapitanVigent">
                    <font-awesome-icon icon="list" size="lg" />
                </button>
                
            </div>

            <div class="col-12 table-responsive-md">
                <transition name="fade" mode="out-in">
                <table class="table" v-if="capitanDown">
                    <thead>
                        <tr>
                            <th scope="col" class="table-dark">#</th>
                            <th scope="col" class="table-dark">CAPITANIA</th>
                            <th scope="col" class="table-dark">BAJA</th>
                        </tr>
                    </thead>   
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>{{ capitanDown.name_boss }}</td>
                            <td><button class="btn btn-outline-danger" @click="downCapitan(capitanDown.id_boss)">
                                <font-awesome-icon icon="arrow-circle-down" size="2x" />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </transition>
                
            </div>
        </div>

    </div>
    <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import modalLoading from '../modal/modalLoading';
const qs = require('qs');

export default {
    data(){
        return{
            capitanList:null,
            ports_vigency:[],
            port_s:null,
            modal_load_id:'loading_port_boss',
            modal_load_title:'Cargando',
            status_send:true,
            port_select:{id:0},
            port_select_d:{id:0},
            capitan:null,
            date_begin:null,
            telephone:null,
            capitanDown:null,
            aux_dn:'DN-0',
            aux_rp:1,
            is_disabled:false,
            header:null,
            config:null,
            persons:null,
            persons_list:[],
            person_select:{
                id:0
            }
        }
    },
    mounted(){
        // if(Vue.auth.getToken()){
        //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
        // }
        // console.log(axios.defaults.headers)
        this.chargePort();
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    methods:{
        mCopyToClipboard(elemento) {
            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada al portapapeles', 'Archivo copiado')
        },
        colorBackground(t){
            let c;
            switch(t){
                case 1:
                    return c={color:'#EA5959', letter:'white'};
                    break;
                case 2:
                    return c={color:'#596DEA', letter:'white'};
                    break;
                case 3:
                    return c={color:'#D4AC0D', letter:'white'};
                    break;
                case 4:
                    return c={color:'#D68910', letter:'white'};
                    break;
                case 5:
                    return c={color:'#EB984E', letter:'black'};
                    break;
                case 6:
                    return c={color:'#F7DC6F', letter:'black'};
                    break;
                case 7:
                    return c={color:'#BDC3C7', letter:'black'};
                    break;
                case 8:
                    return c={color:'#515A5A', letter:'white'};
                    break;
                case 9:
                    return c={color:'#17202A', letter:'white'};
                    break;
                case 10:
                    return c={color:'#922B21', letter:'white'};
                    break;
                default:
                    return c={color:'#16A085', letter:'white'};
                    break;
            }
        },
        async listCapitan(){
            
            // axios.defaults.headers.post['Content-Type']='application/x-www-form-urlencoded';
            // axios.defaults.headers.post['Content-Type']='application/json';
            // axios.defaults.headers.post['Access-Control-Allow-Methods']='*';
            // axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
            let url=`requestCapitan?api_token=${Vue.auth.getToken()}`;
            // let url=`requestCapitan`;
            let lc=await axios.get(url);
            let a=lc.data;
            let a2=lc.data;
            let t='';
            let row;
            let dn_aux='dn-0';
            let cc=1;
            a.forEach((e,i) => {
                
                if(dn_aux!=e.district_short){
                    row=0;
                    dn_aux=e.district_short;
                    a2.forEach((e1,i)=>{
                        if(dn_aux === e1.district_short){
                            row++;
                        }
                    })
                    // por primera vez hacer las tablas con el valor del row
                    // let ca=this.colorBackground(cc);
                    cc=Math.floor(Math.random() * 10)+1;
                    let ca=this.colorBackground(cc);
                    // console.log(Math.floor(Math.random() * 10)+1);
                    let wpp;
                    if(e.telephone>0){
                        wpp=`<a href="https://api.whatsapp.com/send?phone=+591${e.telephone}&text=Hola%20${e.type_short}%20de%20${e.name_port}"  target="_blank" class="btn btn-success"> Mensaje</a>`;
                    }else{
                        wpp='';
                    }
                    t+=`<tr>
                            <td>${(i+1)}</td>
                            
                            <td rowspan="${row}" style="vertical-align:middle; background-color:${ca.color}; color:${ca.letter}">${e.district_short}</td>
                            
                            <td>${e.type_short} ${e.name_port}</td>
                            <td>${e.data_boss}<br>Telefono: ${e.telephone > 0 ? e.telephone:'S/R'}
                                ${wpp}
                            </td>
                        </tr>`;
                }else{
                    let wpp;
                    if(e.telephone>0){
                        wpp=`<a href="https://api.whatsapp.com/send?phone=+591${e.telephone}&text=Hola%20${e.type_short}%20de%20${e.name_port}"  target="_blank" class="btn btn-success"> Mensaje</a>`;
                    }else{
                        wpp='';
                    }
                    t+=`<tr>
                            <td>${(i+1)}</td>

                            <td>${e.type_short} ${e.name_port}</td>
                            <td>${e.data_boss}<br>Telefono: ${e.telephone > 0 ? e.telephone:'S/R'}
                                ${wpp}
                            </td>
                        </tr>`;
                }

            });
            this.capitanList=t;
            

        },
        async chargePort(){
            // this.mShowModal(this.modal_load_id);
            
            // const ports = await axios.get(`getPorts`);        
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);        
            this.ports_vigency=ports.data;
            setTimeout(()=>{
                this.mHideModal(this.modal_load_id);
            },1000)
        },
        sendNewCapitan(){
            // console.log(this.port_select.id)
            // let url=`newCapitanPort`;
            let url=`newCapitanPort?api_token=${Vue.auth.getToken()}`;
            if( this.mValidateNewCapitan() ){
                this.is_disabled=true;
                let new_capitan={
                    id_port:this.port_select.id,
                    id_person:this.person_select.id,
                    capitan:this.person_select.charge,
                    date:this.date_begin,
                    phone:this.telephone
                }
                axios.post(url, qs.stringify(new_capitan))
                    .then((data)=>{
                        // console.log(data)
                        if(!data.data[0].error){
                            toastr.success(data.data[0].response, 'Exito');
                            this.capitan=null;
                            this.date_begin=null;
                            this.telephone=null;
                            this.is_disabled=false;
                            this.person_select.id=0;
                        }else{
                            toastr.error(data.data[0].response, 'Error')
                        }
                    })
                    .catch(err=> {console.log(err); this.is_disabled=false; })
            }            
        },
        mValidateNewCapitan(){
            
            // if(this.capitan===null){
            //     toastr.error('No ha registrado a ningun capitan', 'Error')
            //     return false;    
            // }
            if(this.port_select.id===0){
                toastr.error('Seleccione la Capitania de Puerto', 'Error')
                return false;
            }

            let afi=this.date_begin.split('T');
            this.date_begin=afi[0];

            if(this.date_begin === null || !(this.date_begin.length === 10)){
                toastr.warning('La fecha de inicio en invalida', 'Error');
                return false;
            }
            
            if(this.telephone === null){
                toastr.error('El telefono es invalido', 'Error')
                return false;
            }

            
            return true;
        },
        listCapitanVigent(){
            this.capitanDown=null;
            if(this.port_select_d.id > 0){
                let psd=this.port_select_d.id;
                let url=`getCapitanVigent/${psd}?api_token=${Vue.auth.getToken()}`;
                // let url=`getCapitanVigent/${psd}`;
                axios.get(url)
                .then((data)=>{
                    // console.log(data.data.length);
                    if(data.data.length>0){
                        this.capitanDown=data.data[0];
                    }else{
                        toastr.info('No existe un capitan Asignado', 'Sin asignacion');
                    }
                    
                })
                .catch(err=>{
                    console.log(err)
                })
            }else{
                toastr.error('Seleccione un puerto', 'Error');
            }
        },
        downCapitan(id){
            // let url=`downCapitanVigent/${id}`;
            let url=`downCapitanVigent/${id}?api_token=${Vue.auth.getToken()}`;
            axios.get(url)
            .then( (data) =>{
                if(!data.data[0].error){
                    toastr.success(data.data[0].response, 'Exito');
                    this.capitanDown=null;
                }else{
                    toastr.error(data.data[0].response, 'Error')
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        mShowModal(e){
            $(`#${e}`).modal('show');
        },
        mHideModal(e){
            $(`#${e}`).modal('hide');
        },
        mSelectPerson(data){
            // console.log(data);
            this.person_select.id=data.id;
            this.person_select.complete=`${data.grade} ${data.speciality} ${data.complete}`;
            this.person_select.charge=`${data.grade} ${data.speciality} ${data.complete}`;
            this.telephone=data.phone;

        }
    },
    watch:{
        persons(newPerson){
            axios.get(`searchPerson/${newPerson}?api_token=${Vue.auth.getToken()}`)
            .then((res)=>{
                // console.log(res);
                this.persons_list=res.data;
            }).catch(err=>{
                console.log(err);
            })
        }
    },
    components:{
        'modal-loading':modalLoading
    },
    filters:{
        upCase(value){
            return value.toUpperCase();
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/user/CapitanPort.vue